<ul class="hvac-day-picker">
    <li *ngFor="let status of statusMap; let i = index">
        <hvac-data-block [status]="status">{{dayMap[i]}}</hvac-data-block>
    </li>
</ul>
